import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';

import LoaderTable from '@loaders/LoaderTable';

import InStoreServicesAppointmentOverview from './InStoreServicesAppointmentOverview';

import { Appointments, IAppointmentsPayload } from '@interfaces/myAppointmentInterfaces';

import { InStoreServicesAppointmentsConfig } from '@utils/pages-utils/InStoreServiceUtils';

import { getAccessToken } from '@services/myAppointmentServices';

import * as actions from '@redux-actions/';

import { getLabelFallback, getMockedFile } from '@utils/utils';

import { cloneDeep } from 'lodash';

import { v4 as uuidv4 } from 'uuid';
import axios, { AxiosRequestConfig } from 'axios';
import { mapInStoreServicesAppointments } from '@utils/pages-utils/EyeExamsUtils';
import { RequestStatus } from '@interfaces/mainInterfaces';

export async function getAppointmentsList(
    payload: IAppointmentsPayload,
    config: any
): Promise<any> {
    const { isMockRequest, accessToken, subscriptionKey } = payload;

    if (isMockRequest) {
        const appointmentsList =
            '/data/mocks/my_appointments_in_store_services_get_appointments_list_mock.json';
        return getMockedFile(appointmentsList);
    } else {
        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            url:
                config.callFromComponentToTO.myAppointments.inStoreServices.getAppointmentsList +
                '?nocache=' +
                new Date().getTime(),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
                'Ocp-Apim-Subscription-Key': `${subscriptionKey}`,
            },
        };
        return axios(requestConfig);
    }
}

const InStoreServicesDetails = (): JSX.Element => {
    const config = useSelector((state: RootState) => state.common.config);
    const accessToken = useSelector((state: RootState) => state.myAppointment.accessToken);

    const dispatch = useDispatch();

    const [appointmentsList, setAppointmentsList] = useState<Appointments[]>(null);
    const [appointmentsListRequestStatus, setAppointmentsListRequestStatus] =
        useState<RequestStatus>('IDLE');
    const clonedInStoreServicesAppointmentsConfig = cloneDeep(InStoreServicesAppointmentsConfig);

    const [appointmentsConfig, setAppointmentsConfig] = useState(
        clonedInStoreServicesAppointmentsConfig
    );

    useEffect(() => {
        if (accessToken) {
            setAppointmentsListRequestStatus('LOADING');
            getAppointmentsList(
                {
                    isMockRequest: config.mockRequest,
                    subscriptionKey: config.subscriptionKey,
                    accessToken: accessToken,
                },
                config
            )
                .then(result => {
                    const mappedAppointmentsLists = mapInStoreServicesAppointments(result?.data);
                    setAppointmentsList(mappedAppointmentsLists);
                    setAppointmentsListRequestStatus('SUCCESS');
                })
                .catch(
                    () => (setAppointmentsList(null), setAppointmentsListRequestStatus('ERROR'))
                );
        }

        return () => {
            setAppointmentsList(null), setAppointmentsListRequestStatus('IDLE');
        };
    }, [accessToken]);

    useEffect(() => {
        dispatch(
            getAccessToken({
                isMockRequest: config.mockRequest,
                brand: 'LC',
                userEmail: config.userEmail,
                userId: config.userId,
                storeId: config.storeId,
                role: 'CUSTOMER',
            })
        );
        return () => {
            dispatch(actions.getAccessTokenSuccess(null));
        };
    }, []);

    useEffect(() => {
        appointmentsList?.length &&
            appointmentsList.map(appointment => {
                appointment.changeAllowed
                    ? clonedInStoreServicesAppointmentsConfig.upcoming.appointments.push(
                          appointment
                      )
                    : clonedInStoreServicesAppointmentsConfig.past.appointments.push(appointment);

                setAppointmentsConfig(clonedInStoreServicesAppointmentsConfig);
            });
    }, [appointmentsList]);

    return (
        <div>
            {appointmentsList?.length > 0 &&
                Object.values(appointmentsConfig).map(
                    appointment =>
                        appointment.appointments.length > 0 && (
                            <div key={uuidv4()} className="in-store-services-details">
                                <div
                                    role="region"
                                    aria-label="in-store services details title"
                                    className="in-store-services-details-title primary-title"
                                >
                                    {getLabelFallback(appointment.labelKey)}
                                </div>
                                <div className="in-store-services-details-content">
                                    {appointment.appointments.map(appointment => (
                                        <InStoreServicesAppointmentOverview
                                            key={appointment.appointmentId}
                                            appointment={appointment}
                                        />
                                    ))}
                                </div>
                            </div>
                        )
                )}
            {!appointmentsList && appointmentsListRequestStatus === 'LOADING' && <LoaderTable />}
        </div>
    );
};
export default InStoreServicesDetails;
